import React, { useEffect, useState } from 'react'

import * as S from './styles'
import theme from 'presentation/styles/theme'

export type TabItem = {
  label: string
  componentChildren: React.ReactElement
  disabled?: boolean
}

export type TabsProps = {
  tabItems: TabItem[]
  defaultTab?: number
  borderColor?: keyof typeof theme.ds.colors
  activeColor?: keyof typeof theme.ds.colors
  centered?: boolean
  onChangeTab?(activeIndex: number): void
  tabsMaxWidth?: string
  wrapperMaxWidth?: string
}

const TabsNew = ({
  tabItems,
  defaultTab,
  borderColor = 'neutral200',
  activeColor = 'primary600',
  onChangeTab,
  centered = false,
  tabsMaxWidth,
  wrapperMaxWidth
}: TabsProps) => {
  const [activeIndex, setActiveIndex] = useState(defaultTab || 0)
  const [activePanel, setActivePanel] = useState((<></>) as React.ReactElement)

  const handleChange = (newIndex: number) => {
    const findedTab = tabItems.find((e, idx) => idx === newIndex)
    if (findedTab && findedTab.disabled) {
      return
    }
    setActiveIndex(newIndex)
    if (onChangeTab) {
      onChangeTab(newIndex)
    }
  }

  useEffect(() => {
    const tabFinded = tabItems.find((tab, idx) => tab && idx === activeIndex)
    if (tabFinded) {
      setActivePanel(tabFinded.componentChildren)
    }
  }, [activeIndex, tabItems])

  return (
    <S.Wrapper wrapperMaxWidth={wrapperMaxWidth}>
      <S.StyledTabs
        value={activeIndex}
        onChange={(e, v) => handleChange(v)}
        borderColor={borderColor}
        activeColor={activeColor}
        centered={centered}
        tabsMaxWidth={tabsMaxWidth}
        data-testid="tabs-container"
      >
        {tabItems.map((tab, idx) => (
          <S.StyledTab
            key={idx}
            label={tab.label}
            style={{
              opacity: tab.disabled ? 0.4 : 1
            }}
            activeColor={activeColor}
            data-testid="tab-container"
          />
        ))}
      </S.StyledTabs>
      <S.ActiveTabPanel>{activePanel}</S.ActiveTabPanel>
    </S.Wrapper>
  )
}

export default TabsNew
